import findIndex from 'lodash/findIndex';
import { handleActions } from 'redux-actions';
import { emptyMetaConversation } from '../../../conversation/reducers/conversation';
import { transferToNumberActions } from '../actions/transferToNumberModal';
export const initialState = {
    meta: {
        requestAssistedTransfer: 'succeeded',
        requestBlindTransfer: 'succeeded',
        searchUser: 'succeeded',
    },
    ui: {
        isModalShown: false,
    },
    users: [],
    metaConversation: emptyMetaConversation(),
    transferRequests: [],
};
export const { transferToNumberAssistedRequest, transferToNumberAssistedRequestSucceeded, transferToNumberAssistedRequestFailed, transferToNumberBlindRequest, transferToNumberBlindRequestSucceeded, transferToNumberBlindRequestFailed, transferToNumberAssistedResolve, transferToNumberAssistedResolveSucceeded, transferToNumberAssistedResolveFailed, transferToNumberGetUsersByQuery, transferToNumberGetUsersByQuerySucceeded, transferToNumberGetUsersByQueryFailed, transferToNumberModalOpen, transferToNumberModalClose, transferToNumberResetUsers, transferToNumberRequestStop, 
// WS actions.
transferToNumberWsResponse, transferToNumberWsTransferStarted, transferToNumberWsTransferAnswered, } = transferToNumberActions;
const transferToNumber = handleActions({
    // Show trasnferModal to number modal.
    [transferToNumberModalOpen.toString()]: (state, action) => {
        const metaConversation = Object.assign({}, action.payload.metaConversation);
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: true }), metaConversation: metaConversation });
    },
    // Hide assistedTransferModal modal.
    [transferToNumberModalClose.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [] });
    },
    [transferToNumberResetUsers.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { users: [] });
    },
    [transferToNumberGetUsersByQuery.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchUser: 'loading' }) });
    },
    [transferToNumberGetUsersByQuerySucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchUser: 'succeeded' }), users: Array.isArray(action.payload.data) === true &&
                action.payload.data[0] !== undefined &&
                action.payload.data[0].hits !== undefined
                ? action.payload.data[0].hits
                : [] });
    },
    [transferToNumberGetUsersByQueryFailed.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchUser: 'failed' }) });
    },
    [transferToNumberAssistedRequest.toString()]: (state, action) => {
        const metaConversation = Object.assign({}, action.payload.metaConversation);
        const requestToUser = Object.assign({}, action.payload.requestToUser);
        const requestFromAgent = Object.assign({}, action.payload.requestFromAgent);
        const request = {
            metaConversation: metaConversation,
            requestToUser: requestToUser,
            requestFromAgent: requestFromAgent,
        };
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'loading' }), transferRequests: [
                request,
                ...state.transferRequests.filter((t) => t.metaConversation.conversation.id !==
                    metaConversation.conversation.id),
            ] });
    },
    // We do not remove metaConversation here,
    // we need to wait until transferToNumberAssistedResolveSucceeded/Failed.
    // or transferToNumberAssistedRequestFailed
    [transferToNumberAssistedRequestSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [] });
    },
    // The transfer to number request failed.
    // It does not make sense to keep the metaConversation in the store.
    [transferToNumberAssistedRequestFailed.toString()]: (state, action) => {
        const { metaConversation } = action.payload.action;
        const index = findIndex(state.transferRequests, (assistedTransferRequest) => {
            var _a, _b;
            return (metaConversation !== undefined &&
                ((_b = (_a = assistedTransferRequest === null || assistedTransferRequest === void 0 ? void 0 : assistedTransferRequest.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation) === null || _b === void 0 ? void 0 : _b.id) ===
                    metaConversation.conversation.id);
        });
        if (index > -1) {
            const transferRequests = state.transferRequests.slice();
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }), transferRequests: transferRequests, metaConversation: emptyMetaConversation() });
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }), metaConversation: emptyMetaConversation() });
    },
    [transferToNumberBlindRequest.toString()]: (state, action) => {
        const metaConversation = Object.assign({}, action.payload.metaConversation);
        const requestToUser = Object.assign({}, action.payload.requestToUser);
        const requestFromAgent = Object.assign({}, action.payload.requestFromAgent);
        const request = {
            metaConversation: metaConversation,
            requestToUser: requestToUser,
            requestFromAgent: requestFromAgent,
        };
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestBlindTransfer: 'loading' }), transferRequests: [
                request,
                ...state.transferRequests.filter((t) => t.metaConversation.conversation.id !==
                    metaConversation.conversation.id),
            ] });
    },
    [transferToNumberBlindRequestSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestBlindTransfer: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [], metaConversation: emptyMetaConversation() });
    },
    [transferToNumberBlindRequestFailed.toString()]: (state, action) => {
        const { metaConversation } = action.payload.action;
        const index = findIndex(state.transferRequests, (blindTransferRequest) => {
            var _a, _b;
            return (metaConversation !== undefined &&
                ((_b = (_a = blindTransferRequest === null || blindTransferRequest === void 0 ? void 0 : blindTransferRequest.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation) === null || _b === void 0 ? void 0 : _b.id) ===
                    metaConversation.conversation.id);
        });
        if (index > -1) {
            const transferRequests = state.transferRequests.slice();
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestBlindTransfer: 'failed' }), transferRequests: transferRequests, metaConversation: emptyMetaConversation() });
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }), metaConversation: emptyMetaConversation() });
    },
    [transferToNumberAssistedResolve.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'loading' }) });
    },
    // The transfer to number was resolved.
    // We cleanup the store (by removing the metaConversation).
    [transferToNumberAssistedResolveSucceeded.toString()]: (state, action) => {
        const csid = action.payload.data.csid;
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'succeeded' }), transferRequests: [
                ...state.transferRequests.filter((t) => t.metaConversation.conversation.id !== csid),
            ], metaConversation: emptyMetaConversation() });
    },
    // The transfer to number resolve request failed.
    // We remove the metaConversation from the store.
    [transferToNumberAssistedResolveFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }), metaConversation: emptyMetaConversation() });
    },
    // The transfer to number request was stop (maybe because the conversation was closed/claimed).
    // We remove the metaConversation from the store and closes the transfer modal.
    [transferToNumberRequestStop.toString()]: (state, action) => {
        const { csid } = action.payload;
        const transferRequests = state.transferRequests.slice();
        const index = findIndex(state.transferRequests, (request) => {
            var _a;
            return ((_a = request.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation.id) === csid;
        });
        if (index > -1) {
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { transferRequests: transferRequests, ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [], metaConversation: emptyMetaConversation() });
        }
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [], metaConversation: emptyMetaConversation() });
    },
    // Fired when conversation:transfer_status is received on WS.
    // params.accepted has to be either true/false.
    [transferToNumberWsResponse.toString()]: (state, action) => {
        const { csid, accepted } = action.payload;
        const transferRequests = state.transferRequests.slice();
        const index = findIndex(state.transferRequests, (request) => {
            var _a;
            return (((_a = request.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation.id) === csid &&
                (accepted === true || accepted === false));
        });
        const ui = Object.assign({}, state.ui);
        let users = state.users.slice();
        // If the modal is open and the transfer is completed
        if (ui.isModalShown === true &&
            (accepted === true || accepted === false) &&
            csid === state.metaConversation.conversation.id) {
            ui.isModalShown = false;
            users = [];
        }
        if (index > -1) {
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { ui: ui, transferRequests: transferRequests, users: users, metaConversation: emptyMetaConversation() });
        }
        return Object.assign(Object.assign({}, state), { ui: ui, users: users });
    },
}, initialState);
export default transferToNumber;
